module.exports = __webpack_public_path__ + "img/courses_ud.eb38ded8.svg";